import React, { Component } from 'react';
import ErrorScreen from 'src/Components/ErrorScreen/ErrorScreen';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import autoLogout from 'src/Assets/Images/TimeOut.svg';
import manualLogout from 'src/Assets/Images/ManualLogOut.svg';
import './styles.scss';
import { signIn } from 'src/authConfig';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import { withTranslation } from 'react-i18next';

class Logout extends Component {
  state = {
    isAutomaticLogout: localStorage.getItem('isAutomaticLogout'),
    userLoggedOutData: {
      img: manualLogout,
      header: this.props.t('logoutsuccess_msg'),
      subHeader: '',
    },
    autoLoggedOutData: {
      img: autoLogout,
      header: this.props.t('logoff_msg'),
      subHeader: this.props.t('signin_msg'),
    },
    loginType: '',
    prevLanguage:''
  };
  componentDidMount() {
    let loginType = localStorage.getItem('loginType');
    this.setState({
      loginType,
    });
    this.setAutoLoggedoutData();
  }

  setAutoLoggedoutData = () =>{
    let {t} = this.props;
    let newAutoLoggedoutData = {...this.state.autoLoggedOutData};
    newAutoLoggedoutData.header = t('logoff_msg');
    newAutoLoggedoutData.subHeader = t('signin_msg');
    this.setState({autoLoggedOutData: newAutoLoggedoutData});
  }

  componentDidUpdate() {
    const {t} = this.props;
    
    if(this.state.prevLanguage != localStorage.getItem('activeLanguageCountry'))
    {
      let newUserLoggedOutData = {...this.state.userLoggedOutData}
      newUserLoggedOutData.header = t('logoutsuccess_msg');
      this.setState({userLoggedOutData : newUserLoggedOutData});
      this.setState({prevLanguage: localStorage.getItem('activeLanguageCountry')});

      let newAutoLoggedoutData = {...this.state.autoLoggedOutData};
      newAutoLoggedoutData.header = t('logoff_msg');
      newAutoLoggedoutData.subHeader = t('signin_msg');
      this.setState({autoLoggedOutData: newAutoLoggedoutData});
    }
  }

  analytics = (digitalData) =>{
    let { loginType } =
    this.state;
    AnalyticsService.updateDigitalData(digitalData);
                  AnalyticsService.trackEvent('signin_start');
                  signIn(loginType);
  }
  render() {
    let { isAutomaticLogout, userLoggedOutData, autoLoggedOutData, loginType } =
      this.state;
    const { t } = this.props;

    let digitalData;
    if (loginType?.includes('SFDC')) {
      digitalData = {
        user: {
          profile: {
            profileInfo: {
              loginStatus: 'logged in',
            },
          },
          userType: '',
        },
      };
    } else {
      digitalData = {
        user: {
          profile: {
            profileInfo: {
              loginStatus: 'logged in',
              profileID: '',
            },
          },
          userType: loginType,
        },
      };
    }

    return (
      <div className="logout-wrapper">
        {isAutomaticLogout == 'false' ? (
          <ErrorScreen data={userLoggedOutData}>
            <div className="button-wrapper">
              <p className="info-text">{t('done_yet_msg')}</p>
              <PrimaryButtonGE
                className="btn-class"
                text={t('signin_button')}
                onClick={() => {
                 this.analytics(digitalData);
                }}
              />
            </div>
          </ErrorScreen>
        ) : (
          <ErrorScreen data={autoLoggedOutData}>
            <div className="auto-button-wrapper">
              <PrimaryButtonGE
                className="btn-class"
                text={t('signin_button')}
                onClick={() => {
                  this.analytics(digitalData);
                }}
              />
            </div>
          </ErrorScreen>
        )}
      </div>
    );
  }
}

export default withTranslation()(Logout);
